'use client'

import { Card, Container, Spacer, Text } from '@vinted/web-ui'

import { ClosetPromoPerformanceModel } from '@marketplace-web/vas/vas-data'
import { useTranslate } from '@marketplace-web/shared/i18n'
import { useBreakpoint } from '@marketplace-web/shared/breakpoints'

import { calculateMetricTotals } from '../../../utils/closetPromoPerformance'

type Props = {
  performance: ClosetPromoPerformanceModel
}

const Activity = ({ performance }: Props) => {
  const translate = useTranslate('closet_promotion.performance.activity')
  const breakpoints = useBreakpoint()

  const totalPromotedItemViews = calculateMetricTotals(performance.itemVisitsPerDay).promoted
  const totalPromotedFavourites = performance.favourites.promoted

  return (
    <Card>
      <Container styling={breakpoints.tabletsUp ? Container.Styling.Wide : undefined}>
        <Text as="h2" type={Text.Type.Title} text={translate('title')} />
        <Spacer size={breakpoints.tabletsUp ? Spacer.Size.XLarge : Spacer.Size.Large} />
        <div className="closet-promo-stats__activity-cards">
          <Card>
            <Container>
              <div className="u-flexbox u-flex-direction-column">
                <Text as="span" type={Text.Type.Subtitle} text={translate('clicks')} />
                <Text as="span" type={Text.Type.Title} text={totalPromotedItemViews} />
              </div>
            </Container>
          </Card>
          <Card>
            <Container>
              <div className="u-flexbox u-flex-direction-column">
                <Text as="span" type={Text.Type.Subtitle} text={translate('favourites')} />
                <Text as="span" type={Text.Type.Title} text={totalPromotedFavourites} />
              </div>
            </Container>
          </Card>
        </div>
      </Container>
    </Card>
  )
}

export default Activity
